import classNames from 'classnames';
import React, { Component } from 'react';
import CrossfadeImage from 'react-crossfade-image';
import './ClickableBox.css';

// Props
// title: string
// description: string
// disabled: boolean
// onClickBox: function

export default class ClickableBox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      curImage: 0
    }
  }

  componentDidMount() {
    for (let i = 0; i < this.props.images.length; i++) {
      let img = new Image();
      img.src = this.props.images[i];
    }
    this.interval = setInterval(() => this.changeImage(), (3 + Math.random() * (8 - 3)) * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  changeImage = () => {
    const { images } = this.props;
    const { curImage } = this.state;
    const nextImage = curImage + 1 >= images.length || !images[curImage + 1] ? 0 : curImage + 1;
    this.setState({
      curImage: nextImage
    });
  }

  render() {
    const activeImage = this.props.images[this.state.curImage];
    const itemClasses = classNames('ClickableBox', {
      'ClickableBox--disabled': this.props.disabled
    });
    return (
      <div className={itemClasses} onClick={this.props.onClickBox}>
        <div className={'ClickableBox-contentContainer'}>
          <div className={'ClickableBox-content'}>
            <div className={'ClickableBox-crossfade'}>
              <CrossfadeImage src={activeImage} />
            </div>
            <div className={'ClickableBox-text'}>
              <div className={'ClickableBox-title'}>
                {this.props.title}
              </div>
              <div className={'ClickableBox-description'}>
                {this.props.description}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
